<template>
    <div>
        <form role="form" class="form-horizontal" @submit.stop.prevent v-if="!reservation">
            <div class="form-group">
                <label for="preorderName">Name</label>
                <input v-model="reservationData.name" type="text" name="name" class="form-control" id="preorderName" placeholder="Enter any name">
            </div>
            <div class="form-group">
                <label for="preorderTel">Telephone</label>
                <input v-model="reservationData.telephone" type="text" name="telephone" class="form-control" id="preorderTel" placeholder="Enter a telephone">
            </div>
            <div class="form-group">
                <label for="day">Pickup Day</label>
                <select @change="getSlots" v-model="selectedDate" name="day" class="form-control">
                    <option v-for="day in nextSeven" :value="day" :key="day.unix()">{{day.format("ddd Do MMM YYYY")}}</option>
                </select>
            </div>
            <div class="form-group">
                <label for="time">Pickup Time</label>
                <select :disabled="slots.length < 1" name="time" v-model="selectedSlot" class="form-control">
                    <option :class="slotClass(slot.reserved_at)" :disabled="slot.reserved_at !== null" v-for="slot in slots" :value="slot.uuid" :key="slot.uuid">{{formatTime(slot.start_at)}}</option>
                </select>
            </div>
            <button type="button" @click="reserveSlot" class="btn btn-block btn-primary">
                Reserve A Collection <i class="fa fa-briefcase"></i>
            </button>
        </form>
    </div>
</template>
<script>
    import Moment from 'moment';
    import { extendMoment } from 'moment-range';
    import { getSlots, reserveSlot } from "../../api/collection/timeslots";

    const dateFormat = "DD/MM/YYYY";
    const moment = extendMoment( Moment );
    const today = moment().startOf('hour');
    const range = moment.rangeFromInterval('days',7, today);

    export default {
        name: 'collection-form',

        data() {
            return {
                nextSeven: Array.from(range.by('days')),
                selectedDate: today,
                selectedSlot: {},
                slots: [],
                reservation: false,
                reservationData: {
                    name: '',
                    telephone: '',
                    orderId: Laravel.cartId
                }
            }
        },

        created() {
            this.initialise();
        },

        methods: {
            async initialise() {
                await this
                    .$store
                    .dispatch('setShopCart', Laravel.cartId);
                this.getSlots();
            },

            async getSlots() {
                let slotResponse = await getSlots(this.selectedDate.toJSON());
                this.slots = slotResponse.data;
            },

            async reserveSlot() {
                let reserveResponse = await reserveSlot(this.selectedSlot, this.reservationData);
                this.reservation = reserveResponse.data;
                if (this.cart.items.length > 0) {
                    window.location.href = "/checkout/collection/book";
                } else {
                    window.location.href = "/shop/lighting";
                }

            },

            formatTime(time) {
                return moment(time).format('HH:mm')
            },

            slotClass(reserved) {
                return reserved !== null ? 'disabled' : '';
            }
        },

        computed: {
            cart() {
                return this.$store.getters.currentCart;
            }
        }
    }
</script>